import { useCallback } from 'react';

import { DeferenceHook } from './types';
import { orderLineController, recordController } from 'config/apiFunus';
import { OrderLine } from 'config/apiFunus/generated/data-contracts';
import { Gift } from 'models/Gift';
import { formatDateForRequest } from 'utils/dateManager';
import { showErrorToast } from 'utils/toasts';

export const useDeference = (): DeferenceHook => {
  const createDeference = useCallback(
    (data: OrderLine) => orderLineController.createLocationDeference({
      amount: data.amount,
      articleDescription: data.articleDescription,
      category: data.category,
      channel: data.channel,
      client: data.client,
      code: data.code,
      comments: data.comments,
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      date: formatDateForRequest(data.date) as any,
      dedicatory: data.dedicatory,
      erpId: data.erpId,
      idSupplier: data.idSupplier,
      observations: data.observations,
      paymentLocation: data.paymentLocation,
      price: data.price,
      supplier: data.supplier,
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      time: data.time,
    })
      .then((response) => response)
      .catch((e) => {
        showErrorToast(e.message);
        throw e;
      }),
    [],
  );

  const getDeference = useCallback(
    (recordId: string, articleCode: string) => recordController.getDeferenceInfo({
      articleCode, recordId,
    }),
    [],
  );

  const updateDeferenceStatus = useCallback(
    (recordId: string, gift: Gift) => recordController.updateDeferenceStatus({
      gift, id: recordId,
    }),
    [],
  );

  return {
    createDeference,
    getDeference,
    updateDeferenceStatus,
  };
};
